export default "__VITE_ASSET__C9LWvQQ9__"